import { ServiceError } from '../../contracts';
import type { PlatformSettingsService } from '../../platformContracts';
import { delay, pctx, platformRoot, recordAudit, savePlatform } from './context';

const invalid = (m: string) => new ServiceError(m, 'INVALID');

export const platformSettings: PlatformSettingsService = {
  async get() {
    pctx('platform.settings.manage');
    return delay(platformRoot().settings);
  },
  async save(input) {
    const { actor } = pctx('platform.settings.manage');
    if (!input.platformName.trim()) throw invalid('Platform name is required');
    if (!/^\S+@\S+\.\S+$/.test(input.supportEmail)) throw invalid('Enter a valid support email');
    if (!platformRoot().plans.some((p) => p.id === input.defaultPlanId)) throw invalid('Choose a valid default plan');
    const d = platformRoot();
    d.settings = { ...input, updatedAt: new Date().toISOString() };
    savePlatform();
    recordAudit(actor, 'settings.updated', 'SETTINGS', 'platform', 'Platform settings', `Updated platform settings${input.maintenanceMode ? ' — maintenance mode is ON' : ''}`);
    return delay(d.settings, 500);
  },
};
